export default {
  path: '/admin/dashboard',
  apiClient: null,

  setClient(client) {
    this.apiClient = client;
  },

  async getStats() {
    try {
      const response = await this.apiClient.get(this.path + "/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
}